import {
  addDoc,
  deleteDoc,
  doc,
  FirestoreError,
  orderBy,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { firestore } from "..";
import UserDataStore from "../../../store/UserDataStore";
import { deviceConverter } from "../converters/deviceConverter";
import { CollectionName } from "../types/collections.types";
import { CommonDevice, DesktopClient, DeviceType } from "../types/device.types";
import { createCollection, subscribeCollection } from "./collectionService";

const deviceCollection = createCollection<DeviceType | DesktopClient>(
  CollectionName.DEVICES
);

export const subscribeDevices = (
  onNewSnapshot: (devices: (DeviceType | DesktopClient)[]) => void,
  onError: (err: FirestoreError) => void
) => {
  const user = UserDataStore.currentUser;
  if (!user?.userId) return;
  const deviceQuery = query(
    deviceCollection,
    where("userId", "==", user.userId),
    orderBy("name")
  ).withConverter(deviceConverter);
  return subscribeCollection<DeviceType | DesktopClient>(
    deviceQuery,
    onNewSnapshot,
    onError
  );
};

export const addDevice = async (device: Partial<CommonDevice>) => {
  return await addDoc(deviceCollection, device);
};

export const updateDevice = async (
  deviceId: string,
  deviceParamsToUpdate: Partial<DeviceType | DesktopClient>
) => {
  const deviceRef = doc(
    firestore,
    CollectionName.DEVICES,
    deviceId
  ).withConverter(deviceConverter);
  return await setDoc(deviceRef, deviceParamsToUpdate, { merge: true });
};

export const deleteDevice = async (deviceId: string) => {
  const deviceRef = doc(firestore, CollectionName.DEVICES, deviceId);
  return await deleteDoc(deviceRef);
};

export default deviceCollection;
